/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Team_Settings_Data_PurgeInputs */



/**
* | output |
* | --- |
* | "Delete recorded history" |
*
* @param {Perm_Team_Settings_Data_PurgeInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_team_settings_data_purge = /** @type {((inputs?: Perm_Team_Settings_Data_PurgeInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Team_Settings_Data_PurgeInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалять записанную историю")
	return /** @type {LocalizedString} */ ("Delete recorded history")
});